import type { models } from '../models';
import { Modal } from './modal';
import { formatSpecialString } from '../utils/utils.ts';

export class Alert extends Modal {
  constructor(rewardMessage: models.RewardMessage) {
    super(rewardMessage);
  }

  /**
   * render modal
   */
  public render(rewardMessage: models.RewardMessage) {
    this.modalDiv = document.createElement('div');
    this.modalDiv.className = 'modal-blur-wrapper';

    const modalBoxDiv: HTMLDivElement = document.createElement('div');
    modalBoxDiv.classList = 'alert-box';

    const box: HTMLDivElement = document.createElement('div');
    box.className = 'alert-box-content';
    modalBoxDiv.appendChild(box);

    this._renderAlertIcon(box);

    const textsDiv: HTMLDivElement = document.createElement('div');
    textsDiv.classList = 'alert-texts';

    const title: HTMLDivElement = document.createElement('div');
    title.classList = 'modal-title alert-title';
    title.textContent = rewardMessage.Title as string;
    textsDiv.appendChild(title);

    const text: HTMLDivElement = document.createElement('div');
    text.classList = 'alert-text';
    text.innerHTML = formatSpecialString(rewardMessage.Text as string);
    textsDiv.appendChild(text);
    box.appendChild(textsDiv);

    this._renderButtons(rewardMessage, modalBoxDiv);

    this.modalDiv.appendChild(modalBoxDiv);
    document.body.append(this.modalDiv);
  }

  private _renderAlertIcon(box: HTMLDivElement) {
    const closeButton: HTMLButtonElement = document.createElement('button');
    closeButton.className = 'alert-icon';
    box.appendChild(closeButton);

    const iconDiv: HTMLDivElement = document.createElement('div');
    iconDiv.innerHTML = this.alertSvgIcon;

    closeButton.appendChild(iconDiv);

    this.addButton(closeButton);
  }

  private _renderButtons(
    rewardMessage: models.RewardMessage,
    box: HTMLDivElement
  ) {
    const buttonsDiv: HTMLDivElement = document.createElement('div');
    box.appendChild(buttonsDiv);
    buttonsDiv.className = 'alert-buttons';

    rewardMessage.RewardButtons?.forEach(rewardButton => {
      const btn = document.createElement('button') as HTMLButtonElement;
      btn.classList = 'alert-button';
      btn.textContent = rewardButton.Text as string;

      if (!btn.textContent) {
        btn.textContent = import.meta.env.VITE_CLOSE_BUTTON_DEFAULT_TEXT;
      }
      const clickWraper = () =>
        this.handleClick(rewardButton.Type, rewardButton.Parameters);
      if (!!rewardButton.Type) {
        btn.addEventListener('click', clickWraper);
      }
      buttonsDiv.appendChild(btn);
      this.addButton(btn, clickWraper);
    });
  }
}
